export default "__VITE_ASSET__BfSkEF9T__"